<template>
  <form class="d-flex flex-column px-5" @submit.stop.prevent>
    <div class="text-h6 font-weight-bold mb-3">
      {{ $t('action.panels.LTT_CHOOSE_REP.chooseYourRepresentativeMessage', locale) }}
    </div>
    <v-text-field
      v-model="postalCode"
      v-debounce:1s.lock="handleInputChange"
      :type="signerCountryHasNumericPostcode ? 'number' : 'text'"
      :label="$t('action.ltt.fields.postalCode.label', locale)"
      :rules="[vRules.required]"
      :debounce-events="['input']"
      :loading="fetching"
      :error="forcePostalCodeError"
      class="mb-5"
      color="success"
      name="postal-code"
      hide-details
      outlined
      clearable
    />

    <transition-group
      name="slide-fade"
      tag="div"
      class="reps d-flex justify-center align-center pb-5"
      style="min-height: 170px"
    >
      <div v-if="lttConstituencies.length" key="constituencies-list">
        <div class="text-h6">
          {{
            $tc('action.panels.LTT_CHOOSE_REP.constituencyPlural', lttConstituencies.length, locale)
          }}
        </div>
        <div class="font-weight-bold text-h5 mb-3">
          {{ constituencyNames }}
        </div>
        <div class="text-h6">
          {{ $t('action.panels.LTT_CHOOSE_REP.label', locale) }}
        </div>
        <div class="text-subtitle-2 mb-3">
          {{ $t('action.panels.LTT_CHOOSE_REP.description', locale) }}
        </div>
        <div v-for="constituency in lttConstituencies" :key="constituency.name" class="">
          <div v-for="rep in constituency.representative_set" :key="rep.id" class="rep mb-3">
            <div class="mb-1">
              <div class="text-h5">
                {{ rep.full_name }}
              </div>
              <div v-if="rep.party">
                {{ $t('action.ltt.reps.party', locale) }}:
                <span class="font-weight-bold">{{ rep.party }}</span>
              </div>
            </div>
            <v-btn
              color="primary"
              outlined
              small
              @click.prevent="$store.dispatch('actionForm/handleRepChosen', rep.id)"
            >
              <v-icon>{{ icons.mdiArrowRightBoldCircleOutline }}</v-icon>
              &nbsp;
              {{ $t('action.ltt.buttons.repContact.label', locale) }}
            </v-btn>
          </div>
        </div>
      </div>
      <div v-else key="reps-not-found" class="d-flex flex-column justify-center align-center">
        <div class="text-h4 text-center">
          {{ $t('action.panels.LTT_CHOOSE_REP.postalCodeNotFound', locale) }}
        </div>
        <div class="text-h5 text-center">
          {{ $t('action.panels.LTT_CHOOSE_REP.pleaseSelectValid', locale) }}
        </div>
      </div>
    </transition-group>
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { mdiArrowRightBoldCircleOutline } from '@mdi/js'

// eslint-disable-next-line no-unused-vars
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../utils/tracking'

export default {
  name: 'PanelLttChooseRep',
  data: vm => ({
    EVENT_CATEGORIES,
    postalCode: null,
    vRules: {
      required: value => !!value || vm.$t('action.validation.required', vm.locale)
    },
    icons: {
      mdiArrowRightBoldCircleOutline
    }
  }),
  computed: {
    constituencyNames() {
      return this.lttConstituencies.map(({ name }) => name).join(', ')
    },
    ...mapState('actionForm', [
      'baseUrl',
      'fetching',
      'forcePostalCodeError',
      'lttConstituencies',
      'lttPostalCode',
      'locale'
    ]),
    ...mapGetters('actionForm', ['signerCountryHasNumericPostcode'])
  },
  created() {
    this.postalCode = this.lttPostalCode
  },
  methods: {
    handleInputChange() {
      const { postalCode } = this
      if (postalCode) {
        this.$store.dispatch('actionForm/fetchLttConstituencies', { postalCode })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_panels-common.scss';

.fade-enter-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

form {
  height: 100%;

  .reps {
    position: relative;
    height: 100%;
  }
}
</style>
